export default __webpack_public_path__ + "static/media/edit_icon.56e8fc88.svg";